export default __webpack_public_path__ + "files/unityads.png";